module.exports = __webpack_public_path__ + "img/glass_blowing.9ee18420.gif";